import { Dispatch } from 'react';
import { CoreApi } from '../../../api/api.apiclient';
import { DeskOpeningExceptionRequest } from '../../../api/core/core.types';
import {
  DeleteDeskOpeningExceptionAction,
  DELETE_DESK_OPENING_EXCEPTION,
  GetDeskOpeningExceptionListActuion,
  GET_DESK_OPENING_EXCEPTION_LIST,
  PostDeskOpeningExceptionAction,
  POST_DESK_OPENING_EXCEPTION,
  PutDeskOpeningExceptionAction,
  PUT_DESK_OPENING_EXCEPTION
} from '../types/deskopeningexception.types';

export const getDeskOpeningExceptionList = (deskCode: string) => async (dispatch: Dispatch<GetDeskOpeningExceptionListActuion>) => {
  const response = await CoreApi.DeskOpeningExceptions.listAllDeskOpeningExceptions(deskCode);

  dispatch({
    type: GET_DESK_OPENING_EXCEPTION_LIST,
    payload: {
      deskOpeningExceptions: response
    }
  });
};

export const addNewDeskOpeningException = (request: DeskOpeningExceptionRequest, deskCode: string) => async (dispatch: Dispatch<PostDeskOpeningExceptionAction>) => {
  const response = await CoreApi.DeskOpeningExceptions.addNewDeskOpeningException(request, deskCode);

  dispatch({
    type: POST_DESK_OPENING_EXCEPTION,
    payload: {
      success: true,
      newDeskOpeningException: response.data
    }
  });
};

export const deleteDeskOpeningException = (id: number, deskCode: string) => async (dispatch: Dispatch<DeleteDeskOpeningExceptionAction>) => {
  await CoreApi.DeskOpeningExceptions.deleteDeskOpeningException(id, deskCode);
  dispatch({
    type: DELETE_DESK_OPENING_EXCEPTION,
    payload: {
      success: true
    }
  });
};

export const editDeskOpeningException = (id: number, request: DeskOpeningExceptionRequest, deskCode: string) => async (dispatch: Dispatch<PutDeskOpeningExceptionAction>) => {
  const response = await CoreApi.DeskOpeningExceptions.editDeskOpeningException(id, request, deskCode);

  dispatch({
    type: PUT_DESK_OPENING_EXCEPTION,
    payload: {
      selectedDeskOpeningException: response.data
    }
  });
};
